import MailtoSupport from './MailtoSupport';

export default MailtoSupport;
